module.exports = __webpack_public_path__ + "static/media/keeper-app.ea192575.png";